module.exports = __webpack_public_path__ + "static/media/ipad_11_inch_pro_silver.8b5307aa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_11_inch_pro_silver.jpeg
// module id = 2102
// module chunks = 0